var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"title"},[_vm._v("赛码网技术凝聚了一批忠实企业用户")]),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("数万家企业/机构正在使用赛码")])])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/customer/banner.vue?vue&type=template&id=a645b8d8&scoped=true
// module id = null
// module chunks = 